import cos from '@/scripts/helper/cos';
import async from '@/scripts/tools/async';
import { tips, formatTime } from '@/scripts/tools/utils';
import eventProxy from '@/scripts/tools/eventProxy';

const { lang } = window;
// 文件取回操作
function restoreFiles(fileListObj, params, callback) {
  const succList = [];
  const errList = [];
  const { succedList, failedList } = fileListObj;
  failedList.forEach(item => {
    // 假如有 errorMsg 不做处理（这个错误可能由cos.listFiles产生）
    if ('errorMsg' in item) {
      errList.push(item);
    } else {
      const errorMsg = lang.t('core.resortErrorMessage.notArchive');
      item.errorMsg = errorMsg;
      errList.push(item);
    }
  });
  async.eachLimit(
    succedList,
    10,
    (file, next) => {
      cos.restoreObject(
        {
          Bucket: params.Bucket,
          Region: params.Region,
          Key: file.key || file.Key,
          RestoreRequest: {
            Days: params.expireDays,
            CASJobParameters: {
              Tier: params.mode,
            },
          },
        },
        err => {
          if (err) {
            let error = (err && err.error) || err;
            if (error) {
              error = error.Code || error.code || error.Message;
            }
            const errorMsg = lang.err(`error['${error}']`);
            file.errorMsg = errorMsg;
            errList.push(file);
          } else {
            succList.push(file);
          }
          next();
        },
      );
    },
    () => {
      callback(errList, succList);
    },
  );
}
// 文件过滤，过滤掉非归档存储的文件
function getFileList(source, callback) {
  const succedList = [];
  const failedList = [];

  const filesList = source.files;

  async.eachLimit(
    filesList,
    10,
    (fileItem, next) => {
      if (fileItem.isDir) {
        cos.listFiles(
          {
            Bucket: source.Bucket,
            Region: source.Region,
            Prefix: fileItem.key || fileItem.Key,
          },
          (err, data) => {
            // 需要做错误处理
            if (err) {
              const { error } = err;
              const code = (error && (error.Code || error.code)) || err.code;
              fileItem.errorMsg = lang.err(`error['${code}']`, err);
              failedList.push(fileItem);
            } else {
              data.Contents.forEach(item => {
                if (item.Key.slice(-1) !== '/') {
                  if (item.StorageClass === 'ARCHIVE') {
                    succedList.push(item);
                  } else {
                    failedList.push(item);
                  }
                }
              });
            }
            next();
          },
        );
      } else {
        if (fileItem.StorageClass === 'ARCHIVE') {
          succedList.push(fileItem);
        } else {
          failedList.push(fileItem);
        }
        next();
      }
    },
    () => {
      callback({
        succedList,
        failedList,
      });
    },
  );
}

function filesHandle(source, userParams, callback) {
  let params = {
    Bucket: source.Bucket,
    Region: source.Region,
  };

  params = Object.assign(params, userParams);

  // 判断是否为归档存储的文件 文件为文件夹则会遍历文件夹下的所有文件,将过滤后的结果放到数组里

  getFileList(source, result => {
    restoreFiles(result, params, callback);
  });
}

const restore = {
  handleAchiveFiles(source, userParams, callback) {
    filesHandle(source, userParams, (errList, succList) => {
      callback(succList);
      if (errList && errList.length > 0) {
        const closeNotification = tips.notification({
          type: 'error',
          content: h => {
            const renderFn = errList.map(data => {
              const key = data.name;
              return h('p', key);
            });
            const msg = window.lang.t('state.fail.restore_files', { count: errList.length });
            return h('div', [
              h('p', msg),
              ...renderFn,
              h(
                'a',
                {
                  style: { cursor: 'pointer' },
                  on: {
                    click: () => {
                      closeNotification();
                      eventProxy.emit('failureTable.show', {
                        failedList: errList.map(item => {
                          const Key = item.name || item.Key || item.key;
                          return { Key, Error: item.errorMsg };
                        }),
                        type: 'restore',
                      });
                    },
                  },
                },
                window.lang.t('core.view'),
              ),
            ]);
          },
        });
        eventProxy.once('after-logout', () => {
          if (closeNotification) closeNotification();
        });
      }
    });
  },
  // 处理归档取回的信息
  handleRestoreInfo(str) {
    const obj = {};

    if (!str) {
      obj.status = 'unrestore';
    } else if (str.indexOf('ongoing-request="true"') !== -1) {
      obj.status = 'restoring';
    } else if (str.indexOf('ongoing') !== -1) {
      const matchArr = str.match(/ongoing-request=\"(.*)\", expiry-date=\"(.*)\"/);
      obj.status = 'restored';
      obj.deleteTime = formatTime(new Date(matchArr[2]));
    }

    return obj;
  },
};

// 文件取回处理（并行）

export default restore;
